import React, { useState, useEffect, useRef } from "react";
import AddBillModal from './form'
import { useAuth } from '../../context/auth-context'
import { toast } from 'react-toastify'
import { formatDate, formatToZMW, handlePrint, rootUrl, sumOfArray } from '../../helpers'
import axios from 'axios'
import { FaFileLines } from "react-icons/fa6";
import { PiInvoice } from "react-icons/pi";
import DataTable from "react-data-table-component";
import { FaArrowAltCircleLeft, FaEye, FaPlus, FaSpinner, FaPrint } from "react-icons/fa";
import { customStyles } from "../../styles";
import Modal from "../../components/Modal";
import PayForm from "../user/bills/form";


export default function Payment({allData}) {

  const [bills, setBills] = useState([]);
  const [recs, setRecs] = useState([]);
  const [searchQuery, setSearchQuery] = useState(''); 
  const [showBillModal, setShowBillModal] = useState(false);
  const [showAddBillModal, setShowAddBillModal] = useState(false);
  const [selectedBill, setSelectedBill] = useState([]);
  const [statement, setStatement] = useState([]);
  const [makePayment, setMakePayment] = useState(false);
  const [property, setProperty] = useState([]);
  const [toggle, setToggle] = useState(false);
  const [isDebit, setIsDebit] = useState(true);
  const [items, setItems] = useState([]);
  const [activeTab, setActiveTab] = useState('customers'); // Add state for tab selection

  const auth = useAuth();
  const componentRef = useRef();

  useEffect(() => {
    fetchBills();
  }, []);

  const fetchBills = async () => {
    try {
      const response = await axios.get(rootUrl(`/bills/${auth.user.id}`));
      if(response.data.status === 200){
        setBills(response.data.data);
      }else{
        toast.error("Error fetching bills")
      }
    
    } catch (error) {
      console.error("Error fetching bills:", error);
    }
  };

  const handleViewBill = async (customer) => {
    try {
      const response = await axios.get(rootUrl(`/bill/${customer}`));
      setSelectedBill(response.data.bills);
      setRecs(response.data.recs);
      setProperty(response.data.property)
      setShowBillModal(true);

      const billz = response.data.bills.map((bill) => ({
        ...bill,
        type: "Bill",
        date: new Date(bill.date),
      }));
  
      const receipts = response.data.recs.map((rec) => ({
        ...rec,
        type: "Receipt",
        date: new Date(rec.date),
      }));
  
      // Merge and sort by date
      const combined = [...billz, ...receipts].sort((a, b) => a.date - b.date);
      setStatement(combined);

    } catch (error) {
      console.error("Error fetching bill details:", error);
    }
  };

  const handleAddBill = () => {
    setShowAddBillModal(true);
  };

  const showActBill = (obj, isDeb) => {
    setToggle(true)
    setIsDebit(isDeb)
    setItems(obj)
  }

  const totalOutstanding = bills.reduce((sum, row) => sum + parseFloat(row.amount), 0);

  const columns = [
    {
        name: "Sn",
        selector: (row, index) => index + 1,
        sortable: true,
        width: "50px",
    },
    {
      name: "Bill Date",
      selector: (row) =>(row.date?.substring(0,10)),
      sortable: true,
  },
    {
        name: "Bill No",
        selector: (row) => row.invoice_no,
        sortable: true,
    },
    {
        name: "Customer",
        selector: (row) => `${row.name}`,
        sortable: true,
    },
    {
        name: "Outstanding",
        selector: (row) => formatToZMW(row.amount),
        sortable: true,
    },
    {
        name: "Actions",
        cell: (row) => (
            <button
                onClick={() => handleViewBill(row.customer)}
                className="bg-blue-950 hover:bg-blue-950 text-white px-3 py-1 rounded"
            >
                <FaEye/>
            </button>
        ),
        ignoreRowClick: true,
        allowOverflow: true,
        button: true,
    },
];

const fields = [
  {type: 'select', name: 'billID', label: 'Bill', required: true, options:
    selectedBill?.map((res)=>({
      value:res.b_id,
      label:`${allData.budget?.find(a=>a.id === res.coa_id)?.coa}`
    }))
  },
  {type: 'select', name: 'type', label: 'Type', required: true, options:[
    {value:1, label:'Payment'},
    {value:2, label:'Credit note'},
  ]},
  {type: 'text', name: 'amount', label: 'Amount', required: true},
  {type: 'text', name: 'description', label: 'Description', required: true},
]

const onSubmitForm = async (formdata)=>{

  formdata['uid'] = auth.user.id
  formdata['billID'] = selectedBill[0]?.b_id
  
  try{

    const response = await axios.post(rootUrl('/addPayment'), formdata)

    if(response.data.status === 200){
      toast.success("Submitted successfully")
      setMakePayment(false)
      handleViewBill(selectedBill[0]?.customer)
    }else{
      toast.error("Something went wrong")
    }


  }catch(e){
    toast.error(e?.message)
  }

}

const onSubmit = async (payload) => {

  payload['uid'] = auth.user.id
  try{
      const response = await axios.post(rootUrl('/addBillAndPayment'), payload)
      if(response.data.status === 200){
          toast.success("Submitted successfully")
          setShowAddBillModal(false)
          fetchBills()
      }else{
          toast.error("Something went wrong")
      }

  }catch(e){
      toast.error(e?.message)
  }
}

const filteredData = bills?.length > 0? bills.filter(customer =>
  customer.name.toLowerCase().includes(searchQuery.toLowerCase()) 
):[]

return (
  <div>
    {toggle ? (
      <>
        <FaArrowAltCircleLeft className="m-2 text-3xl text-blue-950" onClick={()=>setToggle(false)}/>
        <AddBillModal data={allData} onSubmit={onSubmit} />
      </>
    ) : (
      <div className="w-full bg-white min-h-[400px] rounded-md mt-10 p-5">
        {/* Navigation Bar */}
        <div className="flex mb-4">
          <button
            className={`px-4 py-2 rounded-l ${activeTab === 'customers' ? 'bg-blue-950 text-white' : 'bg-gray-200 text-gray-800'}`}
            onClick={() => setActiveTab('customers')}
          >
            Customers
          </button>
          <button
            className={`px-4 py-2 rounded-r ${activeTab === 'bills' ? 'bg-blue-950 text-white' : 'bg-gray-200 text-gray-800'}`}
            onClick={() => setActiveTab('bills')}
          >
            Bills
          </button>
        </div>
        {/* End Navigation Bar */}

        {activeTab === 'customers' ? (
          <>
            <div className="flex justify-between">
              <h1 className="font-bold text-2xl flex items-center">
                <PiInvoice className="mr-2" /> Bills
              </h1>
              <button
                onClick={()=>setToggle(true)}
                className="flex items-center bg-blue-950 text-white justify-center border border-gray-300 h-[40px] px-3 ml-2 rounded-md text-[12px]"
              >
                <FaPlus/>
                Add Payment
              </button>
            </div>

            <hr className="my-3" />
            <input
              type="text"
              placeholder="Search..."
              value={searchQuery}
              onChange={e => setSearchQuery(e.target.value)}
              className="mb-4 p-2 border border-gray-300 rounded"
            />

            <span className='text-gray-800 pt-5 text-small'>A list of all bills below</span>

            <DataTable
              title=""
              columns={columns}
              data={filteredData}
              pagination
              highlightOnHover
              striped
              responsive
              customStyles={customStyles}
            />

            <div className="mt-4 text-right font-bold">
              Total Outstanding: {formatToZMW(totalOutstanding)}
            </div>

            {/* View Bill Modal */}
            {showBillModal && (
              <Modal title="View Bill" onClose={() => setShowBillModal(false)}>
                {selectedBill ? (
                  <>
                    <button
                      onClick={() => handlePrint(componentRef)}
                      className="bg-blue-950 text-white px-4 py-2 rounded float-right m-2"
                    >
                      <FaPrint/>
                    </button>
                    {
                      toggle &&
                      <button
                        onClick={()=>setToggle(false)}
                        className="bg-blue-950 text-white px-4 py-2 rounded float-left m-2">
                        <FaArrowAltCircleLeft/>
                      </button>
                    }
                    
                    <div ref={componentRef}>
                      {
                        toggle ? 
                        <PropertyRatesBill items={items} allData={allData} showActBill={showActBill} isDebit={isDebit} property={property} />
                        : 
                        <AllRatesBill statement={statement} selectedBill={selectedBill} allData={allData} showActBill={showActBill} property={property} />
                      }
                    </div>

                    <div className="mt-5">
                      {
                        toggle ?
                        <button className="border rounded p-2 my-2 bg-blue-950 text-white" onClick={()=>setMakePayment(!makePayment)}>Add Payment</button>
                        : null
                      }
              
                      <br/>
                      {
                        makePayment && toggle ?
                        <>
                          <span className="font-bold text-lg">Make Payment</span>
                          <hr className="mb-3" />
                          <PayForm data={items} allData={allData} onSubmitForm={onSubmitForm} />
                        </>
                        : <></>
                      }
                    </div>
                  </>
                ) : (
                  <FaSpinner size={50} className="spinner" />
                )}
              </Modal>
            )}

            {/* Add Bill Modal */}
            {showAddBillModal && (
              <Modal title="Add New Bill" onClose={() => setShowAddBillModal(false)}>
                <AddBillModal data={allData} onSubmit={onSubmit} type={1}/>
              </Modal>
            )}
          </>
        ) : (
          <div className="text-center py-8">
            <h2 className="text-xl font-semibold text-gray-700 mb-2">Bills Management</h2>
            <p className="text-gray-600">Switch to Customers tab to view and manage bills</p>
          </div>
        )}
      </div>
    )}
  </div>
)
}

// Property Rates Bill Component
const PropertyRatesBill = ({items, allData, openingBalance, property, isDebit}) => {
  function getHalfOfYear(date) {
    const month = new Date(date).getMonth() + 1;
    return month <= 6 ? "January to June" : "July to December";
  }

  const prt = property.find(a=>a.id == items.pid)

  let overall = 0
  return (
    <div className="max-w-3xl mx-auto p-6 border rounded-lg shadow-lg">
      <div className="flex justify-center">
        <img className='w-[150px]' src={rootUrl(`/${allData?.council[0]?.path}`)} alt="Council Logo" />
      </div>
     
      <h2 className="text-xl font-bold text-center">{allData?.council[0]?.name}</h2>
      <h3 className="text-lg font-semibold text-center mt-2">{isDebit?prt?'PROPERTY RATES BILL':'INVOICE':'RECEIPT'}</h3>

      {
        isDebit && prt?
        <div className="grid grid-cols-2 gap-6 mt-6 p-4 border border-gray-300 bg-white">
          <div className="space-y-2">
            <p className="text-gray-700"><span className="font-semibold"> Owner:</span> <span>{items?.name}</span></p>
            <p className="text-gray-700"><span className="font-semibold">HSE No and Street:</span> <span>{prt?.street} {prt?.property_no}</span></p>
            <p className="text-gray-700"><span className="font-semibold">Town and Zone:</span> <span>{prt?.location}</span></p>
            <p className="text-gray-700"><span className="font-semibold">Description:</span> <span>{prt?.description}</span></p>
          </div>

          <div className="space-y-2">
            <p className="text-gray-700"><span className="font-semibold">Improve Value:</span> <span>{prt?.improvements}</span></p>
            <p className="text-gray-700"><span className="font-semibold">Land Value:</span> <span>{prt?.land_value}</span></p>
            <p className="text-gray-700"><span className="font-semibold">Rate Used:</span> <span>{parseFloat(prt?.annual_payable) / 2}</span></p>
            <p className="text-gray-700"><span className="font-semibold">Reference No.:</span> <span>{items?.invoice_no}</span></p>
            <p className="text-gray-700"><span className="font-semibold">Hectares .:</span> <span>{parseFloat(prt?.land_ext) == 0.0 ? '':prt?.land_ext}</span></p>
          </div>
        </div>
        :
        <div className="grid grid-cols-2 gap-6 mt-6 p-4 border border-gray-300 bg-white">
          <p className="text-gray-700"><span className="font-semibold"> Customer:</span> <span>{isDebit?items?.name:allData.suppliers.find(a=>a.id == items.cust)?.name}</span></p>
          <p className="text-gray-700"><span className="font-semibold">{isDebit?'Invoice No:':'Receipt No:'} </span> <span>{isDebit?items?.invoice_no:items?.receipt_no}</span></p>
        </div>
      }
      {
        isDebit?
        <table className="w-full mt-4 border-collapse border border-gray-300">
          <thead>
            <tr className="bg-blue-950 text-white">
              <th className="border border-gray-300 p-2">Date</th>
              <th className="border border-gray-300 p-2">Description</th>
              <th className="border border-gray-300 p-2">Balance B/F</th>
              <th className="border border-gray-300 p-2"> Amount </th>
              <th className="border border-gray-300 p-2">Closing Amount</th>
            </tr>
          </thead>
          <tbody>
            <tr className="">
              <td className="border border-gray-300 p-2">{formatDate(items.date.toString())}</td>
              <td className="border border-gray-300 p-2">
                {allData.budget?.find(a=>a.id === items.coa_id)?.coa} : 
                {allData.coa?.find(a=>a.account === allData.budget?.find(a=>a.id === items.coa_id)?.coa)?.name}
              </td>
              <td className="border border-gray-300 p-2">{prt?.opening || 0}</td>
              <td className="border border-gray-300 p-2"> {items.amount} </td>
              <td className="border border-gray-300 p-2">{parseFloat(prt?.opening || 0) + parseFloat(items.amount)}</td>
            </tr>
          </tbody>
        </table>
        :
        <table className="w-full mt-4 border-collapse border border-gray-300">
          <thead>
            <tr className="bg-blue-950 text-white">
              <th className="border border-gray-300 p-2">Date</th>
              <th className="border border-gray-300 p-2">Description</th>
              <th className="border border-gray-300 p-2"> Amount </th>
            </tr>
          </thead>
          <tbody>
            <tr className="">
              <td className="border border-gray-300 p-2">{formatDate(items.date.toString())}</td>
              <td className="border border-gray-300 p-2">
                {items.description}
              </td>
              <td className="border border-gray-300 p-2"> {items.amount} </td>
            </tr>
          </tbody>
        </table>
      }
      
      {
        isDebit?
        <div className="mt-4">
          <p><strong>Amount Due (ZMK):</strong>{parseFloat(prt?.opening || 0) + parseFloat(items.amount)}</p>
        </div>
        : null
      }
      <hr className="my-5" />

      <div className="grid grid-cols-2 gap-4">
        <div>
          <p><strong>Issued By:</strong> {isDebit?'__________________':allData.users.find(a=>a.u_id == items.issuer)?.firstname +' '+allData.users.find(a=>a.u_id == items.issuer)?.lastname} </p>
          <p><strong>Signature:</strong> __________________</p>
        </div>
        <div>
          <p><strong>Received By:</strong> _________________</p>
          <p><strong>Signature:</strong> ___________________</p>
        </div>
      </div>
    </div>
  );
};

// All Rates Bill Component
const AllRatesBill = ({statement, selectedBill, allData, property, showActBill}) => {
  function getHalfOfYear(date) {
    const month = new Date(date).getMonth() + 1;
    return month <= 6 ? "January to June" : "July to December";
  }

  let overall = 0

  const open = sumOfArray(property.map((res)=>parseFloat(res.opening)))

  // Age analysis logic
  const today = new Date();
  const ageBuckets = [
    { label: '0-30 days', min: 0, max: 30 },
    { label: '31-60 days', min: 31, max: 60 },
    { label: '61-90 days', min: 61, max: 90 },
    { label: '91+ days', min: 91, max: Infinity }
  ];
  
  // Get unpaid bills only (type === 'Bill' and not offset by a receipt)
  const unpaidBills = statement.filter(item => item.type === 'Bill' && !statement.some(r => r.type === 'Receipt' && r.b_id === item.b_id && r.amount === item.amount));
  
  // Sum amounts in each age bucket
  const ageAnalysis = ageBuckets.map(bucket => {
    let sum = unpaidBills.reduce((acc, bill) => {
      const billDate = bill.date ? new Date(bill.date) : null;
      if (!billDate) return acc;
      const age = Math.floor((today - billDate) / (1000 * 60 * 60 * 24));
      if (age >= bucket.min && age <= bucket.max) {
        // Find matching receipts for this bill item
        const receipts = statement.filter(r => r.type === 'Receipt' && r.b_id === bill.b_id);
        const receiptsTotal = receipts.reduce((racc, r) => racc + parseFloat(r.amount), 0);
        const unpaidAmount = parseFloat(bill.amount) - receiptsTotal;
        return unpaidAmount > 0 ? acc + unpaidAmount : acc;
      }
      return acc;
    }, 0);
    // Add opening balance to 91+ days bucket
    if (bucket.label === '91+ days') {
      sum += open;
    }
    return { ...bucket, sum };
  });

  return (
    <div className="max-w-3xl mx-auto p-6 border rounded-lg shadow-lg">
      <div className="flex justify-center">
        <img className='w-[150px]' src={rootUrl(`/${allData?.council[0]?.path}`)} alt="Council Logo" />
      </div>
     
      <h2 className="text-xl font-bold text-center">{allData?.council[0]?.name}</h2>
      <h3 className="text-lg font-semibold text-center mt-2">Customer Statement</h3>
      <h3 className="text-lg font-semibold text-center mt-2">{selectedBill[0]?.name}</h3>
      
      <table className="w-full mt-4 border-collapse border border-gray-300">
        <thead>
          <tr className="bg-blue-950 text-white">
            <th className="border border-gray-300 p-2">Date</th>
            <th className="border border-gray-300 p-2">Property</th>
            <th className="border border-gray-300 p-2">Period</th>
            <th className="border border-gray-300 p-2">Account No</th>
            <th className="border border-gray-300 p-2">Type</th>
            <th className="border border-gray-300 p-2"> Amount</th>
            <th className="border border-gray-300 p-2"> Balance</th>
          </tr>
        </thead>
        <tbody>
          <tr className="bg-white">
            <td className="border border-gray-300 p-2">2025-01-01</td>
            <td className="border border-gray-300 p-2"></td>
            <td className="border border-gray-300 p-2"></td>
            <td className="border border-gray-300 p-2"></td>
            <td className="border border-gray-300 p-2">Opening Balance</td>
            <td className="border border-gray-300 p-2"> {open}</td>
            <td className="border border-gray-300 p-2"> {open}</td>
          </tr>
          {statement.reduce(
            (acc, item, index) => {
              const isDebit = item.type === "Bill";
              const amount = parseFloat(item.amount);
              const pty = property.find(a=>a.id == item.pid)
              if (index === 0) {
                acc.cumulativeBalance += open; // Add opening balance only once
              }
        
              // Update cumulative balance
              const newBalance = isDebit
                ? acc.cumulativeBalance + amount
                : acc.cumulativeBalance - amount;
        
              // Push the current row with updated values
              acc.rows.push(
                <tr
                  key={index}
                  className={index % 2 === 0 ? "bg-gray-100" : "bg-white"}
                  onClick={()=>showActBill(item, isDebit)}
                >
                  <td className="px-4 py-2 border">
                    {(item.date.toISOString().substring(0, 10))}
                  </td>
                 
                  <td className="px-4 py-2 border">{pty?.property_no}  {pty?.description}</td>
                  <td className="px-4 py-2 border">{getHalfOfYear(item.date)}</td>
                  <td className="px-4 py-2 border">
                    {
                      isDebit?
                      <>
                        {allData.budget?.find(a=>a.id === item.coa_id)?.coa} : 
                        {allData.coa?.find(a=>a.account === allData.budget?.find(a=>a.id === item.coa_id)?.coa)?.name}
                      </>
                      :
                      <>
                        {allData.budget?.find(a=>a.id === selectedBill?.find(a=>a.id === item.b_id)?.coa_id)?.coa} : 
                        {allData.coa?.find(a=>a.account === allData.budget?.find(a=>a.id === selectedBill?.find(a=>a.id === item.b_id)?.coa_id)?.coa)?.name}
                      </>
                    }
                  </td>
                  <td className="px-4 py-2 border">
                    {isDebit ? "Bill": "Receipt"}
                  </td>
                  <td className="px-4 py-2 border">
                    {isDebit ? formatToZMW(amount) : -(amount)}
                  </td>
                  <td className="px-4 py-2 border">
                    {formatToZMW(newBalance)}
                  </td>
                </tr>
              );
        
              // Update cumulative balance for the next row
              acc.cumulativeBalance = newBalance;
              overall = newBalance
              return acc;
            },
            { rows: [], cumulativeBalance: 0 } // Initial state
          ).rows}
        </tbody>
      </table>

      <div className="mt-4">
        <p><strong>Amount Due (ZMK):</strong>{overall}</p>
      </div>
      
      {/* Age Analysis Table */}
      <div className="mt-6">
        <h4 className="font-semibold mb-2">Age Analysis (Unpaid Bills)</h4>
        <table className="w-full border border-gray-300">
          <thead>
            <tr className="bg-blue-950 text-white">
              {ageBuckets.map(bucket => (
                <th key={bucket.label} className="border p-2">{bucket.label}</th>
              ))}
            </tr>
          </thead>
          <tbody>
            <tr>
              {ageAnalysis.map(a => (
                <td key={a.label} className="border p-2 text-right">{a.sum}</td>
              ))}
            </tr>
          </tbody>
        </table>
      </div>

      <hr className="my-5" />

      <div className="grid grid-cols-2 gap-4">
        <div>
          <p><strong>Issued By:</strong> __________________</p>
          <p><strong>Signature:</strong> __________________</p>
        </div>
        <div>
          <p><strong>Received By:</strong> _________________</p>
          <p><strong>Signature:</strong> ___________________</p>
        </div>
      </div>
    </div>
  );
};
